import { render, staticRenderFns } from "./TakePhotoPrepare.vue?vue&type=template&id=f32b9c5e&scoped=true&"
import script from "./TakePhotoPrepare.vue?vue&type=script&lang=js&"
export * from "./TakePhotoPrepare.vue?vue&type=script&lang=js&"
import style0 from "./TakePhotoPrepare.vue?vue&type=style&index=0&id=f32b9c5e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32b9c5e",
  null
  
)

export default component.exports